import { v4 as uuidv4 } from 'uuid';
import { REMOVE_ALERT, SET_ALERT, REMOVE_EXISTING_ALERTS } from './types';

// sets an alert message
const alertTimeoutSecs = 4;
const customNotificationTimeoutSecs = 5;

export const setAlert = (type: string, message: string) => async (dispatch: any) => {
	const id = uuidv4();
	dispatch({
		type: SET_ALERT,
		payload: { id, type, message },
	});

	// Use longer timeout for custom notifications
	const isCustomNotification = message.includes("Can't find an account");
	const timeout = isCustomNotification ? customNotificationTimeoutSecs : alertTimeoutSecs;

	setTimeout(() => {
		dispatch({
			type: REMOVE_ALERT,
			payload: id,
		});
	}, timeout * 1000);
};

export const removeAlert = (id: string) => async (dispatch: any) => {
	dispatch({
		type: REMOVE_ALERT,
		payload: id,
	});
};

export const removeExistingAlerts = () => async (dispatch: any) => {
	dispatch({
		type: REMOVE_EXISTING_ALERTS,
	});
};
